export const LEAD_STATUS = {
  BLACK_LISTED: "Blocked",
  NOT_SEND: "Not Sent",
  SENT: "Sent",
  TEST: "Test",
  DUPLICATE: "Duplicate",
};
